import Icon from '../Icon';
import React from 'react';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';

const EmptyCart = () => {
  const checkout = useTypedSelector((state) => state.checkout);
  const { emptyCartMessage, emptyCartLink } = checkout.payload;

  return (
    <div
      className={clsx(
        'container',
        'flex',
        'justify-center',
        'items-center',
        'flex-1'
      )}
    >
      <div
        className={clsx(
          'flex',
          'items-center',
          'flex-col',
          'max-w-[768px]',
          'w-full',
          'py-20',
          'lg:py-60'
        )}
      >
        <h1 className="mb-2 text-center uppercase">
          {translate('checkout.empty.title')}
        </h1>
        {emptyCartMessage && (
          <div
            className="mb-6 text-center text-lg"
            dangerouslySetInnerHTML={{
              __html: emptyCartMessage,
            }}
          />
        )}
        {emptyCartLink && (
          <a href={emptyCartLink}>
            <button
              className={clsx(
                'btn',
                'btn--large',
                'btn--outline',
                'uppercase'
              )}
            >
              {translate('checkout.startshopping')}
            </button>
          </a>
        )}
      </div>
    </div>
  );
};

export default EmptyCart;
